<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Wait Time Reports</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Wait Time Reports</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <!-- <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Users</label
            >
            <div>
              <Multiselect
                v-model="selectedUsers"
                mode="tags"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="usersList"
              />
            </div>
          </div> -->
          
          <!-- <div class="col-sm-4" style="margin-top: -18px !important">
            <label class="boldText" style="margin-bottom: 0px !important"
              >Practices</label
            >
              <div>
              <Multiselect
                v-model="selectedPractice"
                placeholder="Select Users"
                :searchable="true"
                :createTag="true"
                :options="practices"
              />
            </div>
          </div> -->

          <div class="col-sm-4">
            <input
              style="margin-bottom: 6px; margin-left: 51px"
              type="text"
              name="daterangePR"
              :value="initDatePR"
              @change="datePickerPR"
              @focus="datePickerPR"
            />
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="
                  position: absolute;
                  margin-top: -34px;
                  margin-left: 230px;
                "
              >
                <span class="ti-calendar"></span>
              </span>
            </div>
          </div>
        </div>
        <p></p>

        <div class="card">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs customtab" role="tablist">
            <li class="nav-item" v-for="(stage, ndxAA) in stages" :key="ndxAA">
              <a
                :class="
                  activeStageId === stage.stageId
                    ? 'nav-link active'
                    : 'nav-link'
                "
                data-toggle="tab"
                href="#home2"
                role="tab"
                @click="stageTabClick(ndxAA)"
                ><span class="hidden-sm-up"></span>
                <span class="hidden-xs-down">{{ stage.stageName }}</span></a
              >
            </li>
          </ul>
          <!-- Tab panes -->

          <div class="tab-content pb-3">
            <div class="tab-pane active" id="home2" role="tabpanel">
              <table
                id="example23"
                data-height="300"
                class="table display table-bordered table-striped no-wrap"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Steps</th>
                    <th>Under 5 Minutes</th>
                    <th>Under 5 To 9 Minutes</th>
                    <th>Under 10 To 14 Minutes</th>
                    <th>Under 15 To 30 Minutes</th>
                    <th>Under 30 To 45 Minutes</th>
                    <th>Under 45 To 60 Minutes</th>
                    <th>Above 60 Minutes</th>
                  </tr>
                </thead>

                <tbody>
                  <tr 
                  v-for="(dt, ndx01) in aDt1" :key="ndx01">
                    <td>{{ ndx01 + 1 }}. {{ dt.stepName }}</td>
                    <td 
                    style="text-align: center;"
                    v-for="(ts, ndx011) in dt.timeSlot" :key="ndx011">
                      {{ ts }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                id="clmtable1"
                data-height="300"
                class="
                  table
                  display
                  table-bordered table-striped
                  no-wrap
                  m-t-20
                "
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Steps</th>
                    <th>Under 1 hour</th>
                    <th>1 To 2 hours</th>
                    <th>2 To 4 hours</th>
                    <th>4 To 8 hours</th>
                    <th>8 To 16 hours</th>
                    <th>16 To 24 hours</th>
                    <th>24 Plus hours</th>
                  </tr>
                </thead>

                <tbody>
                  <tr 
                  v-for="(dt, ndx02) in aDt2" :key="ndx02">
                    <td>{{ ndx02 + 1 }}. {{ dt.stepName }}</td>
                    <td 
                    style="text-align: center;"
                    v-for="(ts, ndx012) in dt.timeSlot" :key="ndx012">
                      {{ ts }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                id="clmtable2"
                data-height="300"
                class="
                  table
                  display
                  table-bordered table-striped
                  no-wrap
                  m-t-20
                "
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Steps</th>
                    <th>Under 1 Day</th>
                    <th>1 To 2 days</th>
                    <th>2 To 4 days</th>
                    <th>4 To 8 days</th>
                    <th>8 To 16 days</th>
                    <th>16 To 32 days</th>
                    <th>32 Plus days</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(dt, ndx03) in aDt3" :key="ndx03">
                    <td>{{ ndx03 + 1 }}. {{ dt.stepName }}</td>
                    <td 
                    style="text-align: center;"
                    v-for="(ts, ndx013) in dt.timeSlot" :key="ndx013">
                      {{ ts }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="tab-pane p-20" id="profile2" role="tabpanel">2</div>
            <div class="tab-pane p-20" id="messages2" role="tabpanel">3</div>
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import localMixin from "./Mixins/WaitTimeReport";
import moment from "moment";
// import Multiselect from "@vueform/multiselect";
// import Swal from "sweetalert2";

export default {
  name: "WaitTimeReport",
  mixins: [localMixin],
  components: {
    // Multiselect,
  },

  data() {
    return {
      dt1: [],
      dt2: [],
      dt3: [],

      aDt1: [
        {
          stageId: 0,
          stepId: 0,
          stepName: "",
        },
      ],

      aDt2: [
        {
          stageId: 0,
          stepId: 0,
          stepName: "",
        },
      ],

      stages: [],
      steps: [],
      users: [],
      practices: [],
      usersList: ["A", "B", "C", "D"],
      selectedUsers: [],

      selectedPractice: "",
      activeStageId: 0,
      activeStageNdx: 0,

      startDatePR: "",
      endDatePR: "",
      initDatePR: "",
      dummyDate: moment(String(new Date())).format("YYYY-MM-DD"),
    };
  }, // data
};
</script>

<style>
</style>